export const API_V1_BASE_URL = 'https://soap-tv.starnet.cz/';
export const API_V2_BASE_URL = 'https://soap-001.mazana.tv/';
